import api from '../api';

export interface IRequisitosAcaoGestorTecnico {
  requerUpload: boolean;
  requerJustificativa: boolean;
  aceitarOuRecusar: boolean;
  visualizarDocumento: boolean;
  requerMultiplosArquivos?: boolean;
  textoCheckbox?: string;
  textoJustificativa?: string;
  textoUpload?: string;
}

export interface IArquivoGestorTecnico {
  id: string;
  descricao: string;
  arquivoNomeDownload: string;
}

export interface IAcaoGestorTecnico {
  id: string;
  acao: string;
  descricao: string;
  tipoUI: string;
  tipoAcao: string;
  descricaoConfirmacao: string;
  requisitos: IRequisitosAcaoGestorTecnico;
  dataLimite?: Date;
  dataExecucao?: Date;
  statusAcao: string;
  documentoRecebido?: IArquivoGestorTecnico;
  sasPropostaId?: string;
  nomeFornecedor?: string;
  valorProposta?: number;
  parecerTecnicoRevisaoId?: string;
}

export interface IGetAcoesGestorTecnicoResult {
  acoes: IAcaoGestorTecnico[];
}

export interface IExecuteAcaoGestorTecnicoResult {
  success: boolean;
  message: string;
  valid: boolean;
}

export const getAcoesGestorTecnico = (ordemCompraId: string) =>
  api.get<IGetAcoesGestorTecnicoResult>(`gestorTecnico/acoes/${ordemCompraId}`);

export const executarAcaoGestorTecnico = (data: FormData) =>
  api.post<IExecuteAcaoGestorTecnicoResult>('gestorTecnico/acoes/executar', data);
